import fetch from '../fetch';

const echartsData = (detail) => {
    if (detail) {
        return detail['echarts']
    }
    return [
        {
            "category": "优",
            "value": 0,
            "percentage": "0%"
        },
        {
            "category": "良",
            "value": 0,
            "percentage": "0%"
        },
        {
            "category": "中",
            "value": 0,
            "percentage": "0%"
        },
        {
            "category": "差",
            "value": 0,
            "percentage": "0%"
        }
    ] 
}

const choicesData = (detail) => {
    if (detail) {
        return detail['choices']
    }
    return [
        "优；选项人数：0；选项占比：0%",
        "良；选项人数：0；选项占比：0%",
        "中；选项人数：0；选项占比：0%",
        "差；选项人数：0；选项占比：0%",
    ]
}

const buildData = (data) => {
    const detail1 =  data['detail1'];
    const detail2 =  data['detail2'];
    const detail3 =  data['detail3'];
    const detail4 =  data['detail4'];
    const detail5 =  data['detail5'];
    return [
        {
            "id": 1,
            "name": "干部听课",
        },
        {
            "id": 2,
            "evalName": "立德树人",
            "pid": 1,
            "evalSubItem": [
                {
                    "id": 7,
                    "subName": "注重课程思政，结合工匠精神等，将社会主义核心价植观融入教学内容或案例中。",
                    "itemId": 2,
                    "choices": choicesData(detail1),
                    "echarts": echartsData(detail1),
                }
            ]
        },
        {
            "id": 3,
            "evalName": "教学设计",
            "pid": 1,
            "evalSubItem": [
                {
                    "id": 8,
                    "subName": "以学生为中心，教学内容适合产业新发展，遵循标准，对接岗位工作过程，职教特色鲜明。",
                    "itemId": 3,
                    "choices": choicesData(detail2),
                    "echarts": echartsData(detail2),
                },
            ]
        },
        {
            "id": 4,
            "evalName": "教学实施",
            "pid": 1,
            "evalSubItem": [
                {
                    "id": 9,
                    "subName": "内容娴熟，导入高效，重难点突出，目标有效达成；师生有效互动，注重课堂学情，及时调整，效果优良。",
                    "itemId": 4,
                    "choices": choicesData(detail3),
                    "echarts": echartsData(detail3),
                },
            ]
        },
        {
            "id": 5,
            "evalName": "信息化教学",
            "pid": 1,
            "evalSubItem": [
                {
                    "id": 10,
                    "subName": "VR、大数据等新技术赋能突出；微课、慕课、数字教材等资源丰富。",
                    "itemId": 5,
                    "choices": choicesData(detail4),
                    "echarts": echartsData(detail4),
                },
            ]
        },
        {
            "id": 6,
            "evalName": "教师素养",
            "pid": 1,
            "evalSubItem": [
                {
                    "id": 11,
                    "subName": "为人师表，热情亲和，态度认真，严谨规范，仪表得体，精神饱满，表述清晰，声音洪亮。无迟到早退。",
                    "itemId": 6,
                    "choices": choicesData(detail5),
                    "echarts": echartsData(detail5),
                },
            ]
        },
    ]
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('leader/listen/analysis/options', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => {
        return buildData(data);
    })
    .then(data => {
        return (data || []).map(evals => {
            return {
                id: evals.id,
                pid: evals.pid,
                label: evals.evalName,
                children: (evals.evalSubItem || []).map(sub => {
                    return {
                        id: sub.id,
                        pid: sub.itemId,
                        label: sub.subName,
                        choices: sub.choices,
                        data: sub.echarts
                    }
                })
            }
        });
    })
    .then(response => {
        var scores = {};
        var parents = {};
        var values = {};

        var keys = [];

        response.forEach(row => {
            parents["P" + row.id] = "P" + row.pid;
            values["P" + row.id] = row.label;

            row.children.forEach(child => {
                var childId = "C" + child.id;
                parents[childId] = "P" + child.pid;
                scores[childId] = child;
                keys.push(childId);
            });
        });

        return {
            scores,
            parents,
            values,
            keys
        };
    }).then(response => {
        var data = response.keys.map(key => {
            return getParents(key, response.parents, []);
        });

        var columnMaxValue = Math.max.apply(Math, data.map(d => d.length));

        var rowsCount = response.keys.length;

        return {
            scores: response.scores,
            values: response.values,
            columnMaxValue,
            rowsCount,
            data: data.map(function (d) {
                var size = columnMaxValue - d.length;
                var index = d.length - 2;
                var value = d[index];
                for (var i = 0; i < size; i++) {
                    d.splice(index + i, 0, value);
                }
                return d;
            })
        };
    }).then(response => {
        var columnMaxValue = response.columnMaxValue;
        var rowsCount = response.rowsCount;

        var grid = [];

        for (var i = 0; i < columnMaxValue; i++) {
            var lastValue = '';
            var lastIndex = 0;

            grid.push([]);

            for (var k = 0; k < rowsCount; k++) {
                var currentValue = response.data[k][i];

                if (lastValue !== currentValue) {
                    lastIndex = k;
                    lastValue = currentValue;

                    grid[i][k] = {
                        rowspan: 1,
                        value: currentValue
                    };
                } else {
                    grid[i][lastIndex].rowspan = grid[i][lastIndex].rowspan + 1;

                    grid[i][k] = {
                        rowspan: 0,
                        value: currentValue
                    };
                }
            }
        }

        var result = [];

        for (var i = 0; i < rowsCount; i++) {
            var row = [];

            for (var k = 0; k < columnMaxValue; k++) {
                row.push(grid[k][i]);
            }

            result.push(row);
        }

        var data = result.map(row => {
            return row.filter(d => d.rowspan !== 0);
        }).map(row => {
            const size = row.length;
            var columns = [];

            var lastValue = '';
            var lastIndex = 0;
            for (var i = 0; i < size; i++) {
                var currentValue = row[i].value;

                var clone = Object.assign({}, row[i], {
                    colspan: 1
                });

                if (currentValue !== lastValue) {
                    lastValue = currentValue;
                    lastIndex = i;
                } else {
                    columns[lastIndex].colspan = columns[lastIndex].colspan + 1;
                    clone.colspan = 0;
                }

                columns.push(clone);
            }
            return columns.filter(d => d.colspan);
        });

        return {
            scores: response.scores,
            values: response.values,
            data: data.map(row => {
                var size = row.length - 1;
                return {
                    columns: row.filter((d, i) => {
                        return i !== size;
                    }),
                    id: row[size].value
                }
            })
        };
    })
    .then(response => {
        var selects = {};
        response.data.forEach((row) => {
            var choice = response.scores[row.id].choices[0];
            selects[row.id] = {
                data: range(+choice.valueLow, +choice.valueHigh),
                value: +choice.valueNormal,
                index: 0
            };
        });

        var result = response.data.map(d => d.columns.length);

        var size = Math.max.apply(Math, result);

        var columns = range(1, size);
        var reverse = columns.reverse();

        return {
            selects: selects,
            scores: response.scores,
            values: response.values,
            data: response.data,
            columns: reverse,
            loading: false
        };
    });
}

const scoreCount = (domain) => {
    return fetch.post('eval/score/count', domain);
};

const getComments = (domain) => {
    return fetch.post('platform/comment/list', domain)
    .then(response => {
        return response.payload.data;
    });
}
/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const queryDetailById = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('eval/result/edit', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        const domain = {
            courseAdd: data.courseAdd,
            lessonAddress: data.lessonAddress,
            orgId: data.orgId,
            orgName: data.orgName,
            employeeId: data.employeeId,
            realName: data.realName,
            classesId: data.classesId,
            classesName: data.classesName,
            courseId: data.courseId,
            courseName: data.courseName,
            lessonNumBg: data.lessonNumBg || 1,
            lessonNumEnd: data.lessonNumEnd || 1,
            weekNum: data.weekNum || 1,
            weekName: data.weekName || "星期一",
            evalId: data.evalId,
            resultComment: data.resultComment,
            resultScore: data.resultScore,
            dudaoName: data.dudaoName
        }
        return {
            data: data.evalTargetList.map(evals => {
                return {
                    id: evals.id,
                    pid: evals.pid,
                    label: evals.evalName,
                    children: evals.evalSubItem.map(sub => {
                        return {
                            id: sub.id,
                            pid: sub.itemId,
                            label: sub.subName,
                            choices: sub.choices,
                            selectLabel: sub.selectLabel,
                            selectScore: sub.selectScore
                        }
                    })
                }
            }),
            domain: domain
        };
    })
    .then(response => {
        var scores = {};
        var parents = {};
        var values = {};

        var keys = [];

        response.data.forEach(row => {
            parents["P" + row.id] = "P" + row.pid;
            values["P" + row.id] = row.label;

            row.children.forEach(child => {
                var childId = "C" + child.id;
                parents[childId] = "P" + child.pid;
                scores[childId] = child;
                keys.push(childId);
            });
        });

        return {
            scores,
            parents,
            values,
            keys,
            domain: response.domain
        };
    }).then(response => {
        var data = response.keys.map(key => {
            return getParents(key, response.parents, []);
        });

        var columnMaxValue = Math.max.apply(Math, data.map(d => d.length));

        var rowsCount = response.keys.length;

        return {
            scores: response.scores,
            values: response.values,
            columnMaxValue,
            rowsCount,
            data: data.map(function (d) {
                var size = columnMaxValue - d.length;
                var index = d.length - 2;
                var value = d[index];
                for (var i = 0; i < size; i++) {
                    d.splice(index + i, 0, value);
                }
                return d;
            }),
            domain: response.domain
        };
    }).then(response => {
        var columnMaxValue = response.columnMaxValue;
        var rowsCount = response.rowsCount;
        
        var grid = [];

        for (var i = 0; i < columnMaxValue; i++) {
            var lastValue = '';
            var lastIndex = 0;

            grid.push([]);

            for (var k = 0; k < rowsCount; k++) {
                var currentValue = response.data[k][i];

                if (lastValue !== currentValue) {
                    lastIndex = k;
                    lastValue = currentValue;

                    grid[i][k] = {
                        rowspan: 1,
                        value: currentValue
                    };
                } else {
                    grid[i][lastIndex].rowspan = grid[i][lastIndex].rowspan + 1;

                    grid[i][k] = {
                        rowspan: 0,
                        value: currentValue
                    };
                }
            }
        }

        var result = [];

        for (var i = 0; i < rowsCount; i++) {
            var row = [];

            for (var k = 0; k < columnMaxValue; k++) {
                row.push(grid[k][i]);
            }

            result.push(row);
        }

        var data = result.map(row => {
            return row.filter(d => d.rowspan !== 0);
        }).map(row => {
            const size = row.length;
            var columns = [];

            var lastValue = '';
            var lastIndex = 0;
            for (var i = 0; i < size; i++) {
                var currentValue = row[i].value;

                var clone = Object.assign({}, row[i], {
                    colspan: 1
                });

                if (currentValue !== lastValue) {
                    lastValue = currentValue;
                    lastIndex = i;
                } else {
                    columns[lastIndex].colspan = columns[lastIndex].colspan + 1;
                    clone.colspan = 0;
                }

                columns.push(clone);
            }
            return columns.filter(d => d.colspan);
        });

        return {
            scores: response.scores,
            values: response.values,
            data: data.map(row => {
                var size = row.length - 1;
                return {
                    columns: row.filter((d, i) => {
                        return i !== size;
                    }),
                    id: row[size].value
                }
            }),
            domain: response.domain
        };
    })
    .then(response => {
        var selects = {};

        response.data.forEach((row) => {
            
            var selectScore = response.scores[row.id].selectScore;

            var index = findSelectScore(response.scores[row.id].choices, +selectScore);
            var choice = response.scores[row.id].choices[index];
            selects[row.id] = {
                data: range(+choice.valueLow, +choice.valueHigh),
                value: +selectScore,
                index: index
            };
        });

        var result = response.data.map(d => d.columns.length);

        var size = Math.max.apply(Math, result);

        var columns = range(1, size);
        var reverse = columns.reverse();



        return {
            selects: selects,
            scores: response.scores,
            values: response.values,
            data: response.data,
            columns: reverse,
            loading: false,
            domain: response.domain
        };
    });
}

const findSelectScore = (choices, selectScore) => {
    var index = -1;
    for(var i = 0 ; i < choices.length; i++ ){
        const choice = choices[i];
        const min = +choice.valueLow;
        const max = +choice.valueHigh
        if(selectScore >= min && selectScore <=max) {
            index = i;
            break;
        }
    }

    return index;
}

const getParents = (id, parents, row) => {
    if (parents.hasOwnProperty(id) === true) {
        return row.unshift(id), getParents(parents[id], parents, row);
    } else {
        return row.slice(1);
    }
}

const range = (start, stop) => {
    var result = [];
    for (stop; stop >= start; stop--) {
        result.push(stop);
    }

    return result;
}

const insert = (domain) => {
    return fetch.post('eval/score/insert', domain);
}

const check = (domain) => {
    return fetch.post('eval/score/check/eval', domain)
    .then(response => {
        return response;
    });
}

const update = (id, domain) => {
    return fetch.post('eval/result/update/'+ id, domain);
}

export default {
    querySearch,
    queryDetailById,
    insert,
    update,
    check,
    scoreCount
}